<div class="main-container centerWithFlex">

    <div class="inner-container">
          <div class="dottedBorder" style="height: 10%;width: 100%;display: flex;
          border-bottom: solid 1px #bebebe;">
                 <div class="dottedBorder" style="width: 2%;height: 100%;">
                       
                 </div>
                 <div class="dottedBorder" style="width: 75%;height: 100%;font-weight:700;
                 display: flex;align-items: center;">
                      User List
                 </div>
                 <!-- <div class="dottedBorder centerWithFlex" style="width: 20%;height: 100%;">
                        <button class="AddFeedButton" (click)="addNewFeed()">Add New Feeds</button>
                 </div> -->
          </div>

          <div class="dottedBorder" style="height: 75%;width: 100%;">
          <div style="height: 10%;width: 100%;"></div>
          <div  style="height: 90%;width: 100%;overflow-y: scroll;">
            <mat-table class="dottedBorder" style="border-top: solid 1px #e9e9e9;width: 100%;font-family: roboto;font-size: 12px;" #table [dataSource]="userList">
 
  
                <ng-container matColumnDef="firstName">
                  <mat-header-cell *matHeaderCellDef style="width:10% !important; flex: 0 0 14% !important;" class="listHeaderStyle">First Name</mat-header-cell>
                  <mat-cell *matCellDef="let element" style="width:10% !important; flex: 0 0 14% !important;"> {{element.firstName}} </mat-cell>
                </ng-container>
            
                <ng-container matColumnDef="lastName">
                  <mat-header-cell *matHeaderCellDef style="width:10% !important; flex: 0 0 14% !important;" class="listHeaderStyle"> Last Name</mat-header-cell>
                  <mat-cell *matCellDef="let element" style="width:10% !important; flex: 0 0 14% !important;"> {{element.lastName}} </mat-cell>
                </ng-container>
            
                <ng-container matColumnDef="userType">
                  <mat-header-cell *matHeaderCellDef style="width:10% !important; flex: 0 0 14% !important;" class="listHeaderStyle"> User Type </mat-header-cell>
                  <mat-cell *matCellDef="let element; let i = index;" style="width:10% !important; flex: 0 0 14% !important;">
                    
                    <mat-select [(value)]="element.userType"  (selectionChange)="userTypeChanged($event.value,element)">
                      <mat-option value="Admin">Admin</mat-option>
                      <mat-option value="User">User </mat-option>
                  </mat-select>
                    
                <!--  {{element.userType}} -->
                  
                  </mat-cell>
                </ng-container>
          
                <ng-container matColumnDef="email">
                    <mat-header-cell *matHeaderCellDef style="width:10% !important; flex: 0 0 14% !important;" class="listHeaderStyle"> Email </mat-header-cell>
                    <mat-cell *matCellDef="let element" style="width:10% !important; flex: 0 0 14% !important;"> {{element.email}} </mat-cell>
                </ng-container>
    
                <ng-container matColumnDef="birthDate">
                    <mat-header-cell *matHeaderCellDef style="width:10% !important; flex: 0 0 14% !important;" class="listHeaderStyle"> DOB </mat-header-cell>
                    <mat-cell *matCellDef="let element" style="width:10% !important; flex: 0 0 14% !important;"> {{element.birthDate}} </mat-cell>
                </ng-container>
    
                <ng-container matColumnDef="createdDate">
                    <mat-header-cell *matHeaderCellDef style="width:10% !important; flex: 0 0 14% !important;"  class="listHeaderStyle"> Created Date </mat-header-cell>
                    <mat-cell *matCellDef="let element" style="width:10% !important; flex: 0 0 14% !important;"> 
                        {{element.createdDate | date:'dd/MM/yyyy  hh.mm aa'}}
                     </mat-cell>
                </ng-container>
    
                <ng-container matColumnDef="action">
                    <mat-header-cell *matHeaderCellDef style="width:10% !important; flex: 0 0 14% !important;" class="listHeaderStyle" > Action </mat-header-cell>
                    <mat-cell *matCellDef="let element" style="width:10% !important; flex: 0 0 14% !important;"> 

                      <mat-slide-toggle [(ngModel)]="element.isActive" (ngModelChange)="ChangeState(element,$event)">{{element.isActive ? 'Active' : 'InActive'}}</mat-slide-toggle>

                        <!-- <mat-icon style="font-size: 20px;" matTooltip="Edit"  (click)="editFeed(element.id)">edit</mat-icon>
                        <mat-icon style="margin-left: 5px;font-size: 20px;" matTooltip="Delete"  (click)="deleteFeed(element.id)">delete_outline</mat-icon> -->
                    </mat-cell>
                </ng-container>
          
            
                <mat-header-row style="width: 100%;"class="listGridHeaderRowStyle" *matHeaderRowDef="displayColumns; sticky: true"></mat-header-row>
                <mat-row style="width: 100%;" *matRowDef="let row; columns: displayColumns;"></mat-row>
            </mat-table>
          </div>
          </div>

       
      

        
          <div class="dottedBorder centerWithFlex" style="height: 15%;width: 100%;">
             <mat-paginator  [length]="total" (page)="getList($event)"
                    [pageSize]="100"
                    [pageSizeOptions]="[10, 25, 100]"
                    aria-label="Select page">
             </mat-paginator>

          </div>
    </div>

</div>